import { Link } from "react-router-dom";
import { ArrowRight, FileText } from "lucide-react";
import CTASection from "./CTASection";

export default function LegalPage({ title, badge, lastUpdated, sections }) {
  return (
    <div data-testid="legal-page">
      <section className="hero-gradient relative overflow-hidden grain">
        <div className="relative max-w-5xl mx-auto px-6 lg:px-10 py-20 md:py-24 text-center">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full glass-strong border border-[#1B4332]/10 text-black text-xs font-semibold mb-6">
            <FileText size={14} /> {badge}
          </span>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-extrabold text-black tracking-tight leading-[1.05]">
            {title}
          </h1>
          {lastUpdated && (
            <p className="mt-5 text-sm text-black/60 uppercase tracking-widest font-semibold">
              Last updated · {lastUpdated}
            </p>
          )}
        </div>
      </section>

      <section className="py-20 md:py-24 bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <div className="space-y-10">
            {sections.map((s, i) => (
              <div key={i}>
                <h2 className="font-display font-bold text-2xl md:text-3xl text-black mb-4 tracking-tight">
                  {i + 1}. {s.heading}
                </h2>
                <div className="text-black/80 leading-relaxed space-y-4">
                  {s.paragraphs.map((p, j) => <p key={j}>{p}</p>)}
                  {s.bullets && (
                    <ul className="list-disc pl-6 space-y-2 text-black/80">
                      {s.bullets.map((b, k) => <li key={k}>{b}</li>)}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 pt-10 border-t border-[#1B4332]/10 text-black/70">
            <p>Questions? Reach out to <a href="mailto:legal@brivo.app" className="text-black font-semibold hover:underline">legal@brivo.app</a> or contact our <Link to="/support" className="text-black font-semibold hover:underline">support team</Link>.</p>
          </div>
        </div>
      </section>

      <CTASection accent="cream" title="Brivo treats your data like our own." subtitle="Transparent, secure, audited. Always." />
    </div>
  );
}
